const SELECTORS = {
    statistic: '.wp-block-ssm-statistic',
    number: '.wp-block-ssm-statistic__number-wrapper',
    content: '.wp-block-ssm-statistic__content',
};

const ANIMATION_CONFIG = {
    threshold: 0.2, // Trigger when 20% of element is visible
    contentDelay: 150, // ms delay for content animation
};

export function initStatistic(statistic) {
    const numberWrapper = statistic.querySelector(SELECTORS.number);
    const content = statistic.querySelector(SELECTORS.content);

    // Skip if already initialized or missing required elements
    if (!numberWrapper || statistic.statisticInitialized) {
        return null;
    }

    try {
        // Add initial state classes (hidden, moved down, transition enabled)
        numberWrapper.classList.add('opacity-0', 'translate-y-8', 'transition-all', 'duration-700', 'ease-out');
        if (content) {
            content.classList.add('opacity-0', 'translate-y-8', 'transition-all', 'duration-700', 'ease-out');
        }

        // Create intersection observer
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        try {
                            // Animate number wrapper - remove hidden state, reset transform
                            numberWrapper.classList.remove('opacity-0', 'translate-y-8');
                            numberWrapper.classList.add('opacity-100', 'translate-y-0');

                            // Animate content with delay
                            if (content) {
                                setTimeout(() => {
                                    content.classList.remove('opacity-0', 'translate-y-8');
                                    content.classList.add('opacity-100', 'translate-y-0');
                                }, ANIMATION_CONFIG.contentDelay);
                            }

                            // Disconnect observer after animation (once only)
                            observer.disconnect();
                        } catch (error) {
                            console.error('Error animating statistic:', error);
                        }
                    }
                });
            },
            {
                threshold: ANIMATION_CONFIG.threshold,
                rootMargin: '0px',
            },
        );

        // Start observing
        observer.observe(statistic);

        // Mark as initialized
        statistic.statisticInitialized = true;

        return {
            destroy() {
                try {
                    // Disconnect observer
                    observer.disconnect();

                    // Remove all animation classes
                    const animationClasses = [
                        'opacity-0',
                        'opacity-100',
                        'translate-y-8',
                        'translate-y-0',
                        'transition-all',
                        'duration-700',
                        'ease-out',
                    ];

                    numberWrapper.classList.remove(...animationClasses);
                    if (content) {
                        content.classList.remove(...animationClasses);
                    }

                    delete statistic.statisticInitialized;
                } catch (error) {
                    console.error('Error destroying statistic animation:', error);
                }
            },
        };
    } catch (error) {
        console.error('Error initializing statistic:', error, statistic);

        return null;
    }
}

export function Statistic() {
    document.querySelectorAll(SELECTORS.statistic).forEach((block) => {
        initStatistic(block);
    });
}
